import { Component,
         Output,
         EventEmitter, 
         ChangeDetectionStrategy,
         ChangeDetectorRef}                 from '@angular/core';
import { TableColumn,
         TableColumnType }              from './../common/table-column';
import { ISortableFilter }              from './../common/sortable-filter';
import { ProductService }               from './../shared/product.service';
import { PeakService }                  from './../shared/peak.service';
import { ProductSortableFilter }        from './product-sortable-filter';
import { ProductDialogComponent }       from './../product-dialog/product-dialog.component';
import { ProductImportDialogComponent } from './../product-import-dialog/product-import-dialog.component';
import { MatDialog }                    from '@angular/material';
import { SavingDialogComponent }        from './../common/saving-dialog.component';
import { ProductModel }                 from './../product-dialog/product.model';
import { MatSnackBar }                  from '@angular/material';
import { Observable }                   from 'rxjs/Observable';
import { UploadService }                from './../shared/upload.service';
import { Globals }                      from './../common/globals';
import { query } from '@angular/core/src/animation/dsl';
import { ProductImportErrorOverviewComponent } from '../product-import-error-overview/product-import-error-overview.component';
import { PortalTypeEnum } from '../login/login.model';
import { calcBindingFlags } from '@angular/core/src/view/util';



@Component({
  selector: 'sa-product-list',
  template: require('./product-list.component.html'),
  styles: [require('./product-list.component.scss')],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductListComponent {

  @Output() columns: Array<TableColumn>;
  @Output() filter = new ProductSortableFilter('orderingIndex');
  @Output() performSearch = new EventEmitter();
  @Output() productUpdated = new EventEmitter();

  public getDataCallback: Function;
  public dataPageCallback: Function;

  private apiService: ProductService;
  private peakService: PeakService;

  private antiCache: number;

  constructor(
    apiService: ProductService,
    peakService: PeakService,
    private dialog: MatDialog,
    private snackbar: MatSnackBar,
    private uploadService: UploadService,
    public globals: Globals,
    private cd: ChangeDetectorRef
  ) {
    this.apiService = apiService;
    this.peakService = peakService;
    this.getDataCallback = this.getData.bind(this);
    this.dataPageCallback = this.getDataPage.bind(this);
    this.antiCache = new Date().getTime();

    this.columns = [
      // new TableColumn(TableColumnType.Text, 'RecUID', 'Jméno', 250),
      // new TableColumn(TableColumnType.Text, 'RecID', 'ID', 60),
      new TableColumn(TableColumnType.Image, 'imagePath', 'Obrázek', 40, true, null, false, null,
          (path) => (!path) ? '<i class="material-icons" style="color: silver;">panorama</i>' :
          `<img src="${this.globals.GetUrlPrefix()}/api/product/getimage/${path}?anticache=${this.antiCache}" height="30">`),
      new TableColumn(TableColumnType.Text, 'vart', 'VART', 50),
      new TableColumn(TableColumnType.Text, 'groupName', 'Skupina', 80),
      new TableColumn(TableColumnType.Text, 'quantityUnit', 'Jednotka', 50),

      new TableColumn(TableColumnType.Money, 'priceCZK', 'Cena CZK', 50),
      new TableColumn(TableColumnType.Money, 'priceEUR', 'Cena EUR', 50),
      //new TableColumn(TableColumnType.Money, 'priceGBP', 'Cena GBP', 50),

      new TableColumn(TableColumnType.Text, 'productDescriptions', 'Název CZ', 160, null, null, null, (val) => {
        var pd = val.find(pd => pd.languageISOCode === 'cs-CZ');
        return !!pd ? pd.description : "";
      }),
      new TableColumn(TableColumnType.Text, 'productDescriptions', 'Název SK', 160, null, null, null, (val) => {
        var pd = val.find(pd => pd.languageISOCode === 'sk-SK');
        return !!pd ? pd.description : "";
      }),

      new TableColumn(TableColumnType.Number, 'vatCZ', 'DPH CZ', 50),
      new TableColumn(TableColumnType.Number, 'vatSK', 'DPH SK', 50),

      new TableColumn(TableColumnType.Bool, 'closeDayCheck', 'Kontrola při uzávěrce', 60),
      new TableColumn(TableColumnType.Bool, 'notActive', 'Neaktivní', 50),
      new TableColumn(TableColumnType.Number, 'availability', 'Dostupnost', 50),
      new TableColumn(TableColumnType.Bool, 'perishable', 'Zkazitelné', 50),
      new TableColumn(TableColumnType.Bool, 'saleable', 'Prodejné', 50),
      new TableColumn(TableColumnType.Text, 'orderingIndex', 'Třídění', 65),
      new TableColumn(TableColumnType.Text, 'productType', 'Typ', 65)
    ];

    if (this.globals.portalType === PortalTypeEnum.Bus) {
      this.columns.splice(6, 0, new TableColumn(TableColumnType.Money, 'priceGBP', 'Cena GBP', 50));
    }
  }

  private getData(filter: ISortableFilter) {
    return this.apiService.getItems(filter);
  }

  private getDataPage(filter: ISortableFilter) {
    return this.apiService.getItems(filter).map(res => {
      return {'items': res.items.map((e) => {
        let t = e['productType'];
        switch (t) {
          case 'GOODS':
            e['productType'] = 'Zboží';
            break;
          case 'PRODUCT':
            e['productType'] = 'Receptura';
            break;
          case 'MATERIAL':
            e['productType'] = 'Surovina';
            break;
          default:
            e['productType'] = 'Zboží';
            break;
        }
        return e;
      })};
    })
  }

  public addNew() {
    let dialogRef = this.dialog.open(ProductDialogComponent, {disableClose: true});
    dialogRef.componentInstance.model = new ProductModel();

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'save') {
        let cloakRef = this.dialog.open(SavingDialogComponent, {disableClose: true});
        this.apiService.insertItem(dialogRef.componentInstance.model)
        .subscribe(res => {
            cloakRef.close();
            this.search();
          });
      } else if (result === 'cancel') {
        this.search();
      }
    });
  }

  public search() {
    this.performSearch.emit(this.filter);
    this.cd.detectChanges();
  }

  public editItem(model: ProductModel) {
    let dialogRef = this.dialog.open(ProductDialogComponent, {disableClose: true});
    dialogRef.componentInstance.model = model;

    dialogRef.afterClosed().subscribe(result => {
      if (result === 'save') {
          this.apiService.updateItem(dialogRef.componentInstance.model.recUID, dialogRef.componentInstance.model)
            .subscribe(res => {
              this.search();
            });
      } else if (result === 'cancel') {
        this.search();
      }
    });
  }

  public import() {
    // let dialogImport = this.dialog.open();
    let dialogRef = this.dialog.open(ProductImportDialogComponent, {disableClose: true});
    dialogRef.afterClosed().subscribe(res => {
      if (res !== '') {
        this.openErrorDialog(res);
      }
    });
  }

  public openErrorDialog(message) {
    let dlg = this.dialog.open(ProductImportErrorOverviewComponent);
    dlg.componentInstance.message = message;
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/product-list/product-list.component.ts